"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UawColumnPlacement;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _density = require("@site/pattern-library-utils/density");
var _text = _interopRequireDefault(require("@ux/text"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _universalAdWidget = require("@ux-dri/universal-ad-widget");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const UawColumnPlacementContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "UawColumnPlacementContainer",
  class: "pl-u1jmazua",
  vars: {
    "u1jmazua-1": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.boxLowContrast.backgroundColor],
    "u1jmazua-3": [({
      sponsoredLabelColor
    }) => sponsoredLabelColor ? sponsoredLabelColor : _intents.default.ux.boxLowContrast.foregroundColor]
  }
});
function UawColumnPlacement({
  sponsoredLabel,
  adPlacementKey,
  universalAdWidgetConfig,
  maxAdsToDisplay = 3,
  backgroundColor,
  sponsoredLabelColor
}) {
  const [adsResponse, setAdsResponse] = (0, _react.useState)();
  const [adsLoading, setAdsLoading] = (0, _react.useState)(true);

  // TODO how do we connect to hivemind to get omsId?
  const omsId = 'baseline';
  const presentationStrategy = {
    name: 'SMALL_VERTICAL_V2',
    resolveLayoutStrategy: () => {
      return {
        Component: _universalAdWidget.SmallVerticalV2
      };
    },
    supportedKevelAdType: _universalAdWidget.KevelAdType.NativeAdV1
  };
  maxAdsToDisplay = universalAdWidgetConfig?.placements[adPlacementKey]?.kevelPlacementConfig.count || maxAdsToDisplay;
  (0, _react.useEffect)(() => {
    (0, _universalAdWidget.fetchAds)({
      adPlacementKey,
      universalAdWidgetConfig,
      omsId,
      presentationStrategy,
      setAdsResponse,
      setAdsLoading
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(UawColumnPlacementContainer, {
    className: "uaw-column-placement",
    "data-cy": "uaw-column-placement",
    backgroundColor: backgroundColor,
    sponsoredLabelColor: sponsoredLabelColor
  }, /*#__PURE__*/_react.default.createElement(_text.default.div, {
    as: "label",
    size: 1,
    "data-cy": "label",
    className: "uaw-column-placement-header text-uppercase",
    text: sponsoredLabel
  }), /*#__PURE__*/_react.default.createElement(_universalAdWidget.UniversalAdWidget, (0, _extends2.default)({
    maxAdsToDisplay: maxAdsToDisplay,
    loading: adsLoading,
    presentationStrategy: presentationStrategy
  }, adsResponse)));
}
UawColumnPlacement.propTypes = {
  sponsoredLabel: _propTypes.default.string.isRequired,
  adPlacementKey: _propTypes.default.string.isRequired,
  universalAdWidgetConfig: _propTypes.default.object.isRequired,
  maxAdsToDisplay: _propTypes.default.number.isRequired,
  backgroundColor: _propTypes.default.string,
  sponsoredLabelColor: _propTypes.default.string
};